import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "sectionCard", "form", "submitButton", "previousButton"]
  static values = { submissionId: Number }

  connect() {
    this.preventBackNavigation()
  }

  preventBackNavigation() {
    history.replaceState(null, "", location.href)
    window.addEventListener("popstate", this.handlePopState.bind(this))
  }

  handlePopState() {
    history.pushState(null, "", location.href)
  }

  disconnect() {
    window.removeEventListener("popstate", this.handlePopState.bind(this))
  }

  submitForm(event) {
    if (!this.validateSection()) {
      event.preventDefault()
      this.showValidationError()
      return
    }
    this.setLoadingState(event.submitter)
  }

  validateSection() {
    return true
  }

  setLoadingState(button) {
    if (!button) return

    button.disabled = true
    button.classList.add("opacity-75", "cursor-wait")

    const originalContent = button.innerHTML
    const isNextButton = button.value === "next"

    if (isNextButton) {
      button.innerHTML = `
        <span>${this.loadingText}</span>
        <svg class="animate-spin h-5 w-5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
      `
    }

    setTimeout(() => {
      button.disabled = false
      button.classList.remove("opacity-75", "cursor-wait")
      button.innerHTML = originalContent
    }, 5000)
  }

  get loadingText() {
    return document.documentElement.lang === "fr" ? "Chargement..." : "Loading..."
  }

  showValidationError() {
    if (this.hasSectionCardTarget) {
      this.sectionCardTarget.classList.add("animate-shake")
      setTimeout(() => {
        this.sectionCardTarget.classList.remove("animate-shake")
      }, 500)
    }
  }
}
